import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

import {
  ProjectsListFragmentDoc,
  ProjectFragmentDoc,
  PublicClipListFragmentDoc,
  SubscriptionProjectFragmentDoc,
} from '../fragments.generated';
import { ProductAccessPeriodUsageFragmentDoc } from '../ProductUsage/operation.generated';

const defaultOptions = {} as const;
export type PersonalProjectsQueryVariables = Types.Exact<{
  inputs: Types.ProjectInputs;
}>;

export type PersonalProjectsQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    personalProjects: {
      __typename?: 'ProjectsConnection';
      edges: Array<{
        __typename?: 'ProjectEdge';
        cursor: string;
        node: {
          __typename?: 'Project';
          id: string;
          createdAt: string;
          updatedAt: string;
          folderId?: string | null;
          driveId?: string | null;
          name: string;
          clientName?: string | null;
          clipsCount: number;
          creatorId: string;
          sequence: any;
          shareableUrl?: string | null;
          studioVersion: Types.StudioProjectVersion;
          sampleRate?: number | null;
          rootDriveId?: string | null;
          defaultPauseLength?: number | null;
          bulkPauseLength?: number | null;
          shareable?: {
            __typename?: 'ProjectShareable';
            url?: string | null;
            deletedAt?: string | null;
          } | null;
          projectAccess: {
            __typename?: 'ProjectAccess';
            id: string;
            viewerAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
              permissions: string;
            } | null;
            teamWideAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
            } | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        hasNextPage: boolean;
      };
    };
  };
};

export type SharedProjectsQueryVariables = Types.Exact<{
  inputs: Types.ProjectInputs;
}>;

export type SharedProjectsQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    sharedProjects: {
      __typename?: 'ProjectsConnection';
      edges: Array<{
        __typename?: 'ProjectEdge';
        cursor: string;
        node: {
          __typename?: 'Project';
          id: string;
          createdAt: string;
          updatedAt: string;
          folderId?: string | null;
          driveId?: string | null;
          name: string;
          clientName?: string | null;
          clipsCount: number;
          creatorId: string;
          sequence: any;
          shareableUrl?: string | null;
          studioVersion: Types.StudioProjectVersion;
          sampleRate?: number | null;
          rootDriveId?: string | null;
          defaultPauseLength?: number | null;
          bulkPauseLength?: number | null;
          shareable?: {
            __typename?: 'ProjectShareable';
            url?: string | null;
            deletedAt?: string | null;
          } | null;
          projectAccess: {
            __typename?: 'ProjectAccess';
            id: string;
            viewerAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
              permissions: string;
            } | null;
            teamWideAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
            } | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        hasNextPage: boolean;
      };
    };
  };
};

export type TeamProjects_V2QueryVariables = Types.Exact<{
  inputs: Types.ProjectInputs;
}>;

export type TeamProjects_V2Query = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    teamProjects: {
      __typename?: 'ProjectsConnection';
      edges: Array<{
        __typename?: 'ProjectEdge';
        cursor: string;
        node: {
          __typename?: 'Project';
          id: string;
          createdAt: string;
          updatedAt: string;
          folderId?: string | null;
          driveId?: string | null;
          name: string;
          clientName?: string | null;
          clipsCount: number;
          creatorId: string;
          sequence: any;
          shareableUrl?: string | null;
          studioVersion: Types.StudioProjectVersion;
          sampleRate?: number | null;
          rootDriveId?: string | null;
          defaultPauseLength?: number | null;
          bulkPauseLength?: number | null;
          shareable?: {
            __typename?: 'ProjectShareable';
            url?: string | null;
            deletedAt?: string | null;
          } | null;
          projectAccess: {
            __typename?: 'ProjectAccess';
            id: string;
            viewerAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
              permissions: string;
            } | null;
            teamWideAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
            } | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        hasNextPage: boolean;
      };
    };
  };
};

export type WorkspaceProjectsQueryVariables = Types.Exact<{
  inputs: Types.ProjectInputs;
}>;

export type WorkspaceProjectsQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    workspaceProjects: {
      __typename?: 'ProjectsConnection';
      edges: Array<{
        __typename?: 'ProjectEdge';
        cursor: string;
        node: {
          __typename?: 'Project';
          id: string;
          createdAt: string;
          updatedAt: string;
          folderId?: string | null;
          driveId?: string | null;
          name: string;
          clientName?: string | null;
          clipsCount: number;
          creatorId: string;
          sequence: any;
          shareableUrl?: string | null;
          studioVersion: Types.StudioProjectVersion;
          sampleRate?: number | null;
          rootDriveId?: string | null;
          defaultPauseLength?: number | null;
          bulkPauseLength?: number | null;
          shareable?: {
            __typename?: 'ProjectShareable';
            url?: string | null;
            deletedAt?: string | null;
          } | null;
          projectAccess: {
            __typename?: 'ProjectAccess';
            id: string;
            viewerAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
              permissions: string;
            } | null;
            teamWideAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
            } | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        hasNextPage: boolean;
      };
    };
  };
};

export type SuggestedProjectsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SuggestedProjectsQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    suggestedProjects: {
      __typename?: 'ProjectsConnection';
      edges: Array<{
        __typename?: 'ProjectEdge';
        cursor: string;
        node: {
          __typename?: 'Project';
          id: string;
          createdAt: string;
          updatedAt: string;
          folderId?: string | null;
          driveId?: string | null;
          name: string;
          clientName?: string | null;
          clipsCount: number;
          creatorId: string;
          sequence: any;
          shareableUrl?: string | null;
          studioVersion: Types.StudioProjectVersion;
          sampleRate?: number | null;
          rootDriveId?: string | null;
          defaultPauseLength?: number | null;
          bulkPauseLength?: number | null;
          shareable?: {
            __typename?: 'ProjectShareable';
            url?: string | null;
            deletedAt?: string | null;
          } | null;
          projectAccess: {
            __typename?: 'ProjectAccess';
            id: string;
            viewerAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
              permissions: string;
            } | null;
            teamWideAccessRole?: {
              __typename?: 'ProjectAccessRole';
              id: Types.ProjectAccessRoleEnum;
            } | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        hasNextPage: boolean;
      };
    };
  };
};

export type UserProjectQueryVariables = Types.Exact<{
  inputs: Types.UserProjectInputs;
}>;

export type UserProjectQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    project?: {
      __typename?: 'Project';
      defaultPauseLength?: number | null;
      bulkPauseLength?: number | null;
      id: string;
      createdAt: string;
      updatedAt: string;
      folderId?: string | null;
      driveId?: string | null;
      name: string;
      clientName?: string | null;
      clipsCount: number;
      creatorId: string;
      sequence: any;
      shareableUrl?: string | null;
      studioVersion: Types.StudioProjectVersion;
      sampleRate?: number | null;
      rootDriveId?: string | null;
      voices: Array<{ __typename?: 'ProjectVoices'; id: number }>;
      shareable?: {
        __typename?: 'ProjectShareable';
        url?: string | null;
        deletedAt?: string | null;
      } | null;
      projectAccess: {
        __typename?: 'ProjectAccess';
        id: string;
        viewerAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
          permissions: string;
        } | null;
        teamWideAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
        } | null;
      };
    } | null;
  };
};

export type SharedProjectQueryVariables = Types.Exact<{
  inputs: Types.SharedProjectInputs;
  clipsInputs: Types.ProjectClipsInputs_V2;
}>;

export type SharedProjectQuery = {
  __typename?: 'Query';
  sharedProject?: {
    __typename?: 'Project';
    id: string;
    createdAt: string;
    updatedAt: string;
    folderId?: string | null;
    driveId?: string | null;
    name: string;
    clientName?: string | null;
    clipsCount: number;
    creatorId: string;
    sequence: any;
    shareableUrl?: string | null;
    studioVersion: Types.StudioProjectVersion;
    sampleRate?: number | null;
    rootDriveId?: string | null;
    defaultPauseLength?: number | null;
    bulkPauseLength?: number | null;
    clips_V2: {
      __typename?: 'ClipsConnection';
      edges: Array<{
        __typename?: 'ClipsEdge';
        cursor?: string | null;
        node: {
          __typename?: 'Clip';
          id: string;
          projectId: string;
          name: string;
          createdAt: string;
          actorId: string;
          index: number;
          sequence: string;
          fileName: string;
          text: string;
          textFormat?: string | null;
          src: string;
          isDeleted?: boolean | null;
          isCreditableBy?: string | null;
          audioFormat: string;
          combinedFrom?: Array<string> | null;
          isComplete: boolean;
          localSrc?: string | null;
          failedWithError?: string | null;
          streamRequest?: StreamRequest | null;
          ttsVersion?: string | null;
          actor: {
            __typename?: 'ClipActor';
            id: number;
            image: string;
            name: string;
            initials: string;
            isCustomActor?: boolean | null;
            variant: {
              __typename?: 'ActorVariant';
              id: number;
              locale: string;
              version: string;
              isArchived?: boolean | null;
              variantType: {
                __typename?: 'ActorVariantType';
                id: Types.ActorVariantTypeId;
                label: string;
                description?: string | null;
              };
              versions: {
                __typename?: 'ActorVariantVersions';
                previous?: {
                  __typename?: 'TTSModelRelease';
                  model: string;
                  label: string;
                  description?: string | null;
                  overrideSpeakerVariantId?: number | null;
                  features: Array<string>;
                } | null;
                latest: {
                  __typename?: 'TTSModelRelease';
                  model: string;
                  label: string;
                  description?: string | null;
                  overrideSpeakerVariantId?: number | null;
                  features: Array<string>;
                };
                next?: {
                  __typename?: 'TTSModelRelease';
                  model: string;
                  label: string;
                  description?: string | null;
                  overrideSpeakerVariantId?: number | null;
                  features: Array<string>;
                } | null;
                preview?: {
                  __typename?: 'TTSModelRelease';
                  model: string;
                  label: string;
                  description?: string | null;
                  overrideSpeakerVariantId?: number | null;
                  features: Array<string>;
                } | null;
              };
            };
          };
        };
        highlights?: Array<{
          __typename?: 'ClipsSearchResultHighlights';
          fieldName: string;
          highlight: string;
        }> | null;
      }>;
      pageInfo?: {
        __typename?: 'PageInfo';
        endCursor?: string | null;
        hasNextPage: boolean;
      } | null;
    };
    shareable?: {
      __typename?: 'ProjectShareable';
      url?: string | null;
      deletedAt?: string | null;
    } | null;
    projectAccess: {
      __typename?: 'ProjectAccess';
      id: string;
      viewerAccessRole?: {
        __typename?: 'ProjectAccessRole';
        id: Types.ProjectAccessRoleEnum;
        permissions: string;
      } | null;
      teamWideAccessRole?: {
        __typename?: 'ProjectAccessRole';
        id: Types.ProjectAccessRoleEnum;
      } | null;
    };
  } | null;
};

export type CreateProjectMutationVariables = Types.Exact<{
  inputs: Types.CreateProjectInputs;
}>;

export type CreateProjectMutation = {
  __typename?: 'Mutation';
  createProject: {
    __typename?: 'CreateProjectMutationResponse';
    code: string;
    success: boolean;
    message: string;
    project?: {
      __typename?: 'Project';
      id: string;
      createdAt: string;
      updatedAt: string;
      folderId?: string | null;
      driveId?: string | null;
      name: string;
      clientName?: string | null;
      clipsCount: number;
      creatorId: string;
      sequence: any;
      shareableUrl?: string | null;
      studioVersion: Types.StudioProjectVersion;
      sampleRate?: number | null;
      rootDriveId?: string | null;
      defaultPauseLength?: number | null;
      bulkPauseLength?: number | null;
      shareable?: {
        __typename?: 'ProjectShareable';
        url?: string | null;
        deletedAt?: string | null;
      } | null;
      projectAccess: {
        __typename?: 'ProjectAccess';
        id: string;
        viewerAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
          permissions: string;
        } | null;
        teamWideAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
        } | null;
      };
    } | null;
    userProductAccessPeriodUsage?: {
      __typename?: 'ProductAccessPeriodUsage';
      id: string;
      projects: number;
      clipsGenerated: number;
      clipsCredited: number;
      takesGenerated: number;
      takesDownloaded: number;
      downloadedTakesDurationMs: any;
      downloadedTakesTextLength: number;
      generatedTakesTextLength: number;
      generatedTakesDurationMs: any;
      folders: number;
      workspaces: number;
      periodStart: number;
      periodEnd: number;
      usageScope: Types.ProductAccessUsageScope;
    } | null;
    teamProductAccessPeriodUsage?: {
      __typename?: 'ProductAccessPeriodUsage';
      id: string;
      projects: number;
      clipsGenerated: number;
      clipsCredited: number;
      takesGenerated: number;
      takesDownloaded: number;
      downloadedTakesDurationMs: any;
      downloadedTakesTextLength: number;
      generatedTakesTextLength: number;
      generatedTakesDurationMs: any;
      folders: number;
      workspaces: number;
      periodStart: number;
      periodEnd: number;
      usageScope: Types.ProductAccessUsageScope;
    } | null;
  };
};

export type DeleteProjectMutationVariables = Types.Exact<{
  inputs: Types.DeleteProjectInputs;
}>;

export type DeleteProjectMutation = {
  __typename?: 'Mutation';
  deleteProject: {
    __typename?: 'DeleteProjectMutationResponse';
    code: string;
    success: boolean;
    message: string;
    projectId?: string | null;
    userProductAccessPeriodUsage?: {
      __typename?: 'ProductAccessPeriodUsage';
      id: string;
      projects: number;
      clipsGenerated: number;
      clipsCredited: number;
      takesGenerated: number;
      takesDownloaded: number;
      downloadedTakesDurationMs: any;
      downloadedTakesTextLength: number;
      generatedTakesTextLength: number;
      generatedTakesDurationMs: any;
      folders: number;
      workspaces: number;
      periodStart: number;
      periodEnd: number;
      usageScope: Types.ProductAccessUsageScope;
    } | null;
    teamProductAccessPeriodUsage?: {
      __typename?: 'ProductAccessPeriodUsage';
      id: string;
      projects: number;
      clipsGenerated: number;
      clipsCredited: number;
      takesGenerated: number;
      takesDownloaded: number;
      downloadedTakesDurationMs: any;
      downloadedTakesTextLength: number;
      generatedTakesTextLength: number;
      generatedTakesDurationMs: any;
      folders: number;
      workspaces: number;
      periodStart: number;
      periodEnd: number;
      usageScope: Types.ProductAccessUsageScope;
    } | null;
  };
};

export type RenameProjectMutationVariables = Types.Exact<{
  inputs: Types.RenameProjectInputs;
}>;

export type RenameProjectMutation = {
  __typename?: 'Mutation';
  renameProject: {
    __typename?: 'UpdateProjectMutationResponse';
    code: string;
    success: boolean;
    message: string;
    project?: {
      __typename?: 'Project';
      id: string;
      createdAt: string;
      updatedAt: string;
      folderId?: string | null;
      driveId?: string | null;
      name: string;
      clientName?: string | null;
      clipsCount: number;
      creatorId: string;
      sequence: any;
      shareableUrl?: string | null;
      studioVersion: Types.StudioProjectVersion;
      sampleRate?: number | null;
      rootDriveId?: string | null;
      defaultPauseLength?: number | null;
      bulkPauseLength?: number | null;
      shareable?: {
        __typename?: 'ProjectShareable';
        url?: string | null;
        deletedAt?: string | null;
      } | null;
      projectAccess: {
        __typename?: 'ProjectAccess';
        id: string;
        viewerAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
          permissions: string;
        } | null;
        teamWideAccessRole?: {
          __typename?: 'ProjectAccessRole';
          id: Types.ProjectAccessRoleEnum;
        } | null;
      };
    } | null;
  };
};

export type ProjectTypeChangedSubscriptionVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ProjectTypeChangedSubscription = {
  __typename?: 'Subscription';
  projectTypeChanged: {
    __typename?: 'ChangeProjectTypeEvent';
    projectId: string;
    fromType: Types.ProjectTypeEnum;
    toType: Types.ProjectTypeEnum;
    uniqueCacheUserIds?: Array<string> | null;
  };
};

export type ProjectAccessChangedSubscriptionVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ProjectAccessChangedSubscription = {
  __typename?: 'Subscription';
  projectAccessChanged: {
    __typename?: 'ChangeProjectAccessEvent';
    projectId: string;
    action: Types.ProjectAccessActionEnum;
    subject: Types.ProjectAccessChangedSubject;
  };
};

export type MigrateProjectMutationVariables = Types.Exact<{
  inputs: Types.MigrateProjectInputs;
}>;

export type MigrateProjectMutation = {
  __typename?: 'Mutation';
  migrateProject: {
    __typename?: 'MigrateProjectMutationResponse';
    code: string;
    success: boolean;
    message: string;
    projectId?: string | null;
  };
};

export type TranslateProjectMutationVariables = Types.Exact<{
  inputs: Types.TranslateProjectInputs;
}>;

export type TranslateProjectMutation = {
  __typename?: 'Mutation';
  translateProject: {
    __typename?: 'TranslateProjectResponse';
    code: string;
    success: boolean;
    message: string;
    projectSpec?: {
      __typename?: 'ProjectSpec';
      id: string;
      createdAt: string;
      updatedAt: string;
      folderId?: string | null;
      driveId?: string | null;
      name: string;
      creatorId: string;
      clientName?: string | null;
      sectionsCount: number;
      sequence: any;
      sampleRate?: number | null;
      studioVersion: Types.StudioProjectVersion;
      rootDriveId?: string | null;
      sections: Array<{
        __typename?: 'ProjectSectionSpec';
        id: string;
        name: string;
        sequence: string;
        projectId: string;
        avatarId: number;
        avatarVariantId: number;
        defaultTTSVersion?: string | null;
        createdAt: string;
        updatedAt: string;
        text: string;
        formattedText: string;
      }>;
    } | null;
  };
};

export type ProjectEntityChangedSubscriptionVariables = Types.Exact<{
  inputs: Types.ProjectEntityChangedSubscriptionInputs;
}>;

export type ProjectEntityChangedSubscription = {
  __typename?: 'Subscription';
  projectEntityChanged: {
    __typename?: 'ProjectEntityChangedEvent';
    projectId: string;
    changeType: Types.EntityChangeType;
    eventTime: string;
    projectEntity: {
      __typename?: 'SubscriptionProject';
      id: string;
      createdAt: string;
      updatedAt: string;
      name: string;
      creatorId: string;
      clientName?: string | null;
      studioVersion: Types.StudioProjectVersion;
      shareable?: { __typename?: 'ProjectShareable'; url?: string | null } | null;
    };
  };
};

export type UpdateProjectVoicesMutationVariables = Types.Exact<{
  inputs: Types.UpdateProjectVoicesInputs;
}>;

export type UpdateProjectVoicesMutation = {
  __typename?: 'Mutation';
  updateProjectVoices: {
    __typename?: 'UpdateProjectVoicesMutationResponse';
    code: string;
    success: boolean;
    message: string;
    project?: {
      __typename?: 'Project';
      id: string;
      voices: Array<{ __typename?: 'ProjectVoices'; id: number }>;
    } | null;
  };
};

export const PersonalProjectsDocument = gql`
  query PersonalProjects($inputs: ProjectInputs!) {
    user {
      id
      personalProjects(inputs: $inputs) {
        ...ProjectsListFragment
      }
    }
  }
  ${ProjectsListFragmentDoc}
`;

/**
 * __usePersonalProjectsQuery__
 *
 * To run a query within a React component, call `usePersonalProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalProjectsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function usePersonalProjectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PersonalProjectsQuery,
    PersonalProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PersonalProjectsQuery, PersonalProjectsQueryVariables>(
    PersonalProjectsDocument,
    options
  );
}
export function usePersonalProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PersonalProjectsQuery,
    PersonalProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PersonalProjectsQuery, PersonalProjectsQueryVariables>(
    PersonalProjectsDocument,
    options
  );
}
export type PersonalProjectsQueryHookResult = ReturnType<typeof usePersonalProjectsQuery>;
export type PersonalProjectsLazyQueryHookResult = ReturnType<
  typeof usePersonalProjectsLazyQuery
>;
export type PersonalProjectsQueryResult = Apollo.QueryResult<
  PersonalProjectsQuery,
  PersonalProjectsQueryVariables
>;
export const SharedProjectsDocument = gql`
  query SharedProjects($inputs: ProjectInputs!) {
    user {
      id
      sharedProjects(inputs: $inputs) {
        ...ProjectsListFragment
      }
    }
  }
  ${ProjectsListFragmentDoc}
`;

/**
 * __useSharedProjectsQuery__
 *
 * To run a query within a React component, call `useSharedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedProjectsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSharedProjectsQuery(
  baseOptions: Apollo.QueryHookOptions<SharedProjectsQuery, SharedProjectsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SharedProjectsQuery, SharedProjectsQueryVariables>(
    SharedProjectsDocument,
    options
  );
}
export function useSharedProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedProjectsQuery,
    SharedProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SharedProjectsQuery, SharedProjectsQueryVariables>(
    SharedProjectsDocument,
    options
  );
}
export type SharedProjectsQueryHookResult = ReturnType<typeof useSharedProjectsQuery>;
export type SharedProjectsLazyQueryHookResult = ReturnType<
  typeof useSharedProjectsLazyQuery
>;
export type SharedProjectsQueryResult = Apollo.QueryResult<
  SharedProjectsQuery,
  SharedProjectsQueryVariables
>;
export const TeamProjects_V2Document = gql`
  query TeamProjects_v2($inputs: ProjectInputs!) {
    user {
      id
      teamProjects(inputs: $inputs) {
        ...ProjectsListFragment
      }
    }
  }
  ${ProjectsListFragmentDoc}
`;

/**
 * __useTeamProjects_V2Query__
 *
 * To run a query within a React component, call `useTeamProjects_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useTeamProjects_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamProjects_V2Query({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useTeamProjects_V2Query(
  baseOptions: Apollo.QueryHookOptions<
    TeamProjects_V2Query,
    TeamProjects_V2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamProjects_V2Query, TeamProjects_V2QueryVariables>(
    TeamProjects_V2Document,
    options
  );
}
export function useTeamProjects_V2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamProjects_V2Query,
    TeamProjects_V2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamProjects_V2Query, TeamProjects_V2QueryVariables>(
    TeamProjects_V2Document,
    options
  );
}
export type TeamProjects_V2QueryHookResult = ReturnType<typeof useTeamProjects_V2Query>;
export type TeamProjects_V2LazyQueryHookResult = ReturnType<
  typeof useTeamProjects_V2LazyQuery
>;
export type TeamProjects_V2QueryResult = Apollo.QueryResult<
  TeamProjects_V2Query,
  TeamProjects_V2QueryVariables
>;
export const WorkspaceProjectsDocument = gql`
  query WorkspaceProjects($inputs: ProjectInputs!) {
    user {
      id
      workspaceProjects(inputs: $inputs) {
        ...ProjectsListFragment
      }
    }
  }
  ${ProjectsListFragmentDoc}
`;

/**
 * __useWorkspaceProjectsQuery__
 *
 * To run a query within a React component, call `useWorkspaceProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceProjectsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useWorkspaceProjectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkspaceProjectsQuery,
    WorkspaceProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceProjectsQuery, WorkspaceProjectsQueryVariables>(
    WorkspaceProjectsDocument,
    options
  );
}
export function useWorkspaceProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkspaceProjectsQuery,
    WorkspaceProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceProjectsQuery, WorkspaceProjectsQueryVariables>(
    WorkspaceProjectsDocument,
    options
  );
}
export type WorkspaceProjectsQueryHookResult = ReturnType<
  typeof useWorkspaceProjectsQuery
>;
export type WorkspaceProjectsLazyQueryHookResult = ReturnType<
  typeof useWorkspaceProjectsLazyQuery
>;
export type WorkspaceProjectsQueryResult = Apollo.QueryResult<
  WorkspaceProjectsQuery,
  WorkspaceProjectsQueryVariables
>;
export const SuggestedProjectsDocument = gql`
  query SuggestedProjects {
    user {
      id
      suggestedProjects {
        ...ProjectsListFragment
      }
    }
  }
  ${ProjectsListFragmentDoc}
`;

/**
 * __useSuggestedProjectsQuery__
 *
 * To run a query within a React component, call `useSuggestedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuggestedProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SuggestedProjectsQuery,
    SuggestedProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SuggestedProjectsQuery, SuggestedProjectsQueryVariables>(
    SuggestedProjectsDocument,
    options
  );
}
export function useSuggestedProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SuggestedProjectsQuery,
    SuggestedProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SuggestedProjectsQuery, SuggestedProjectsQueryVariables>(
    SuggestedProjectsDocument,
    options
  );
}
export type SuggestedProjectsQueryHookResult = ReturnType<
  typeof useSuggestedProjectsQuery
>;
export type SuggestedProjectsLazyQueryHookResult = ReturnType<
  typeof useSuggestedProjectsLazyQuery
>;
export type SuggestedProjectsQueryResult = Apollo.QueryResult<
  SuggestedProjectsQuery,
  SuggestedProjectsQueryVariables
>;
export const UserProjectDocument = gql`
  query UserProject($inputs: UserProjectInputs!) {
    user {
      id
      project(inputs: $inputs) {
        ...ProjectFragment
        defaultPauseLength
        bulkPauseLength
        voices {
          id
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`;

/**
 * __useUserProjectQuery__
 *
 * To run a query within a React component, call `useUserProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUserProjectQuery(
  baseOptions: Apollo.QueryHookOptions<UserProjectQuery, UserProjectQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserProjectQuery, UserProjectQueryVariables>(
    UserProjectDocument,
    options
  );
}
export function useUserProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserProjectQuery, UserProjectQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserProjectQuery, UserProjectQueryVariables>(
    UserProjectDocument,
    options
  );
}
export type UserProjectQueryHookResult = ReturnType<typeof useUserProjectQuery>;
export type UserProjectLazyQueryHookResult = ReturnType<typeof useUserProjectLazyQuery>;
export type UserProjectQueryResult = Apollo.QueryResult<
  UserProjectQuery,
  UserProjectQueryVariables
>;
export const SharedProjectDocument = gql`
  query SharedProject(
    $inputs: SharedProjectInputs!
    $clipsInputs: ProjectClipsInputs_V2!
  ) {
    sharedProject(inputs: $inputs) {
      ...ProjectFragment
      clips_V2(inputs: $clipsInputs) {
        ...PublicClipListFragment
      }
    }
  }
  ${ProjectFragmentDoc}
  ${PublicClipListFragmentDoc}
`;

/**
 * __useSharedProjectQuery__
 *
 * To run a query within a React component, call `useSharedProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedProjectQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      clipsInputs: // value for 'clipsInputs'
 *   },
 * });
 */
export function useSharedProjectQuery(
  baseOptions: Apollo.QueryHookOptions<SharedProjectQuery, SharedProjectQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SharedProjectQuery, SharedProjectQueryVariables>(
    SharedProjectDocument,
    options
  );
}
export function useSharedProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedProjectQuery,
    SharedProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SharedProjectQuery, SharedProjectQueryVariables>(
    SharedProjectDocument,
    options
  );
}
export type SharedProjectQueryHookResult = ReturnType<typeof useSharedProjectQuery>;
export type SharedProjectLazyQueryHookResult = ReturnType<
  typeof useSharedProjectLazyQuery
>;
export type SharedProjectQueryResult = Apollo.QueryResult<
  SharedProjectQuery,
  SharedProjectQueryVariables
>;
export const CreateProjectDocument = gql`
  mutation createProject($inputs: CreateProjectInputs!) {
    createProject(inputs: $inputs) {
      code
      success
      message
      project {
        ...ProjectFragment
      }
      userProductAccessPeriodUsage {
        ...ProductAccessPeriodUsageFragment
      }
      teamProductAccessPeriodUsage {
        ...ProductAccessPeriodUsageFragment
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ProductAccessPeriodUsageFragmentDoc}
`;
export type CreateProjectMutationFn = Apollo.MutationFunction<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(
    CreateProjectDocument,
    options
  );
}
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;
export const DeleteProjectDocument = gql`
  mutation deleteProject($inputs: DeleteProjectInputs!) {
    deleteProject(inputs: $inputs) {
      code
      success
      message
      projectId
      userProductAccessPeriodUsage {
        ...ProductAccessPeriodUsageFragment
      }
      teamProductAccessPeriodUsage {
        ...ProductAccessPeriodUsageFragment
      }
    }
  }
  ${ProductAccessPeriodUsageFragmentDoc}
`;
export type DeleteProjectMutationFn = Apollo.MutationFunction<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDeleteProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(
    DeleteProjectDocument,
    options
  );
}
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;
export const RenameProjectDocument = gql`
  mutation RenameProject($inputs: RenameProjectInputs!) {
    renameProject(inputs: $inputs) {
      code
      success
      message
      project {
        ...ProjectFragment
      }
    }
  }
  ${ProjectFragmentDoc}
`;
export type RenameProjectMutationFn = Apollo.MutationFunction<
  RenameProjectMutation,
  RenameProjectMutationVariables
>;

/**
 * __useRenameProjectMutation__
 *
 * To run a mutation, you first call `useRenameProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameProjectMutation, { data, loading, error }] = useRenameProjectMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useRenameProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameProjectMutation,
    RenameProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenameProjectMutation, RenameProjectMutationVariables>(
    RenameProjectDocument,
    options
  );
}
export type RenameProjectMutationHookResult = ReturnType<typeof useRenameProjectMutation>;
export type RenameProjectMutationResult = Apollo.MutationResult<RenameProjectMutation>;
export type RenameProjectMutationOptions = Apollo.BaseMutationOptions<
  RenameProjectMutation,
  RenameProjectMutationVariables
>;
export const ProjectTypeChangedDocument = gql`
  subscription ProjectTypeChanged {
    projectTypeChanged {
      projectId
      fromType
      toType
      uniqueCacheUserIds
    }
  }
`;

/**
 * __useProjectTypeChangedSubscription__
 *
 * To run a query within a React component, call `useProjectTypeChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectTypeChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTypeChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectTypeChangedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ProjectTypeChangedSubscription,
    ProjectTypeChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ProjectTypeChangedSubscription,
    ProjectTypeChangedSubscriptionVariables
  >(ProjectTypeChangedDocument, options);
}
export type ProjectTypeChangedSubscriptionHookResult = ReturnType<
  typeof useProjectTypeChangedSubscription
>;
export type ProjectTypeChangedSubscriptionResult =
  Apollo.SubscriptionResult<ProjectTypeChangedSubscription>;
export const ProjectAccessChangedDocument = gql`
  subscription ProjectAccessChanged {
    projectAccessChanged {
      projectId
      action
      subject
    }
  }
`;

/**
 * __useProjectAccessChangedSubscription__
 *
 * To run a query within a React component, call `useProjectAccessChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectAccessChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAccessChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectAccessChangedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ProjectAccessChangedSubscription,
    ProjectAccessChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ProjectAccessChangedSubscription,
    ProjectAccessChangedSubscriptionVariables
  >(ProjectAccessChangedDocument, options);
}
export type ProjectAccessChangedSubscriptionHookResult = ReturnType<
  typeof useProjectAccessChangedSubscription
>;
export type ProjectAccessChangedSubscriptionResult =
  Apollo.SubscriptionResult<ProjectAccessChangedSubscription>;
export const MigrateProjectDocument = gql`
  mutation migrateProject($inputs: MigrateProjectInputs!) {
    migrateProject(inputs: $inputs) {
      code
      success
      message
      projectId
    }
  }
`;
export type MigrateProjectMutationFn = Apollo.MutationFunction<
  MigrateProjectMutation,
  MigrateProjectMutationVariables
>;

/**
 * __useMigrateProjectMutation__
 *
 * To run a mutation, you first call `useMigrateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateProjectMutation, { data, loading, error }] = useMigrateProjectMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMigrateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MigrateProjectMutation,
    MigrateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MigrateProjectMutation, MigrateProjectMutationVariables>(
    MigrateProjectDocument,
    options
  );
}
export type MigrateProjectMutationHookResult = ReturnType<
  typeof useMigrateProjectMutation
>;
export type MigrateProjectMutationResult = Apollo.MutationResult<MigrateProjectMutation>;
export type MigrateProjectMutationOptions = Apollo.BaseMutationOptions<
  MigrateProjectMutation,
  MigrateProjectMutationVariables
>;
export const TranslateProjectDocument = gql`
  mutation translateProject($inputs: TranslateProjectInputs!) {
    translateProject(inputs: $inputs) {
      code
      success
      message
      projectSpec {
        id
        createdAt
        updatedAt
        folderId
        driveId
        name
        creatorId
        clientName
        sectionsCount
        sequence
        sampleRate
        studioVersion
        rootDriveId
        sections {
          id
          name
          sequence
          projectId
          avatarId
          avatarVariantId
          defaultTTSVersion
          createdAt
          updatedAt
          text
          formattedText
        }
      }
    }
  }
`;
export type TranslateProjectMutationFn = Apollo.MutationFunction<
  TranslateProjectMutation,
  TranslateProjectMutationVariables
>;

/**
 * __useTranslateProjectMutation__
 *
 * To run a mutation, you first call `useTranslateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranslateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [translateProjectMutation, { data, loading, error }] = useTranslateProjectMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useTranslateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TranslateProjectMutation,
    TranslateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TranslateProjectMutation, TranslateProjectMutationVariables>(
    TranslateProjectDocument,
    options
  );
}
export type TranslateProjectMutationHookResult = ReturnType<
  typeof useTranslateProjectMutation
>;
export type TranslateProjectMutationResult =
  Apollo.MutationResult<TranslateProjectMutation>;
export type TranslateProjectMutationOptions = Apollo.BaseMutationOptions<
  TranslateProjectMutation,
  TranslateProjectMutationVariables
>;
export const ProjectEntityChangedDocument = gql`
  subscription ProjectEntityChanged($inputs: ProjectEntityChangedSubscriptionInputs!) {
    projectEntityChanged(inputs: $inputs) {
      projectId
      changeType
      eventTime
      projectEntity {
        ...SubscriptionProjectFragment
      }
    }
  }
  ${SubscriptionProjectFragmentDoc}
`;

/**
 * __useProjectEntityChangedSubscription__
 *
 * To run a query within a React component, call `useProjectEntityChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectEntityChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEntityChangedSubscription({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useProjectEntityChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ProjectEntityChangedSubscription,
    ProjectEntityChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ProjectEntityChangedSubscription,
    ProjectEntityChangedSubscriptionVariables
  >(ProjectEntityChangedDocument, options);
}
export type ProjectEntityChangedSubscriptionHookResult = ReturnType<
  typeof useProjectEntityChangedSubscription
>;
export type ProjectEntityChangedSubscriptionResult =
  Apollo.SubscriptionResult<ProjectEntityChangedSubscription>;
export const UpdateProjectVoicesDocument = gql`
  mutation UpdateProjectVoices($inputs: UpdateProjectVoicesInputs!) {
    updateProjectVoices(inputs: $inputs) {
      code
      success
      message
      project {
        id
        voices {
          id
        }
      }
    }
  }
`;
export type UpdateProjectVoicesMutationFn = Apollo.MutationFunction<
  UpdateProjectVoicesMutation,
  UpdateProjectVoicesMutationVariables
>;

/**
 * __useUpdateProjectVoicesMutation__
 *
 * To run a mutation, you first call `useUpdateProjectVoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectVoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectVoicesMutation, { data, loading, error }] = useUpdateProjectVoicesMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateProjectVoicesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectVoicesMutation,
    UpdateProjectVoicesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectVoicesMutation,
    UpdateProjectVoicesMutationVariables
  >(UpdateProjectVoicesDocument, options);
}
export type UpdateProjectVoicesMutationHookResult = ReturnType<
  typeof useUpdateProjectVoicesMutation
>;
export type UpdateProjectVoicesMutationResult =
  Apollo.MutationResult<UpdateProjectVoicesMutation>;
export type UpdateProjectVoicesMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectVoicesMutation,
  UpdateProjectVoicesMutationVariables
>;
